module.exports = {
	// accuweather

	geoLocationURL: `https://dataservice.accuweather.com/locations/v1/cities/geoposition/search?apikey=XzPAPcfHHboIjNxp8QUMJxrFWak91weM&q=`,

	locationsURL:
		"https://dataservice.accuweather.com/locations/v1/cities/search",

	weatherURL:
		"https://dataservice.accuweather.com/currentconditions/v1/",

	apiKey: "DGeolksGjfzsea3W7XxqY6lTH3vRtZmX",

	apiKey2: "XzPAPcfHHboIjNxp8QUMJxrFWak91weM",

	geoApiKey: "at_uIaUhrlyjngrcBACfwfEjFnf8GaF1",

	geoURL:
		"https://geo.ipify.org/api/v2/country,city?apiKey=at_uIaUhrlyjngrcBACfwfEjFnf8GaF1",

	ipURL: "https://ip-api.com/json/",
};
